/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

const prefix = "data-dnd";

const dragHandleBase = `${prefix}-drag-handle`;

export const dragHandle = {
	base: dragHandleBase,
	draggableId: `${dragHandleBase}-draggable-id`,
	contextId: `${dragHandleBase}-context-id`
};

const draggableBase = `${prefix}-draggable`;

export const draggable = {
	base: draggableBase,
	draggableId: `${draggableBase}-id`,
	contextId: `${draggableBase}-context-id`
};

const droppableBase = `${prefix}-droppable`;

export const droppable = {
	base: droppableBase,
	droppableId: `${droppableBase}-id`,
	contextId: `${droppableBase}-context-id`
};

const placeholderBase = `${prefix}-placeholder`;

export const placeholder = {
	base: placeholderBase,
	contextId: `${placeholderBase}-context-id`
};
